import React from 'react';

const Sidebar = ({ sidebarSections, activeSection, setActiveSection }) => {
  return (
    <div className="block bg-white rounded-2xl shadow-lg p-1 md:p-6 h-fit sticky border border-gray-100 backdrop-blur-sm max-md:bg-gray-200/50 w-full max-md:fixed max-md:z-50 bottom-0 left-0">
      <h3 className="text-lg font-bold mb-6 text-gray-800 border-b pb-3 max-md:hidden">Quick Navigation</h3>
      <nav className="md:space-y-3 max-md:flex overflow-auto max-md:gap-2">
        {Object.entries(sidebarSections).map(([id, section]) => (
          <button
            key={id}
            onClick={() => setActiveSection(id)}
            className={`flex max-md:min-w-20 max-md:flex-col max-md:justify-between items-center p-3 rounded-xl transition-all duration-300 cursor-pointer w-full text-left ${activeSection === id
                ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md'
                : 'hover:bg-blue-50 text-gray-600 hover:text-blue-600'
              }`}
          >
            <i className={`${section.icon} md:mr-3 w-5`}></i>
            <span className="text-xs">{section.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
